import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import styled from '@emotion/styled';
import { ResetIcon } from '../Icons/ResetIcon';

const ResetFilterWrapper = styled.div`
    display: flex;
    color: ${({ theme }) => theme.colors.white[100]};
    text-decoration: underline;
    gap: 6px;
    font-size: 14px;
    line-height: 21px;
    align-items: center;
    cursor: pointer;
`;

const StyledResetIcon = styled(ResetIcon)`
    height: 15px;
    width: 15px;
    fill: ${({ theme }) => theme.colors.white[100]};
`;

export const ResetFilterBtn = ({ onClick }: { onClick: React.EventHandler<any> }) => (
    <ResetFilterWrapper onClick={onClick}>
        <StyledResetIcon />
        <span>{__('Reset Search', 'dreamlines')}</span>
    </ResetFilterWrapper>
);
